import api from './axiosConfig';

export type TutorialSeenAction = 'skipped' | 'completed';

/** GET /tutorials: 表示可否とこのユーザーの既読ページ */
export interface TutorialStatus {
  enabled: boolean;
  disabled_pages: string[];
  seen_pages: string[];
}

/** 管理画面 GET/PUT /admin/tutorials */
export interface AdminTutorialSetting {
  enabled: boolean;
  disabled_pages: string[];
  /** ページキーごとの既読（スキップ/完了）ユーザー数 */
  view_counts: Record<string, number>;
  updated_at: string | null;
  deleted?: number;
}

interface Envelope<T> {
  success: boolean;
  data: T;
}

const tutorialService = {
  async getStatus(): Promise<TutorialStatus> {
    const response = await api.get<Envelope<TutorialStatus>>('/tutorials');
    return response.data.data;
  },

  async markSeen(pageKey: string, action: TutorialSeenAction): Promise<void> {
    await api.post('/tutorials/seen', { page_key: pageKey, action });
  },

  async getAdminSetting(): Promise<AdminTutorialSetting> {
    const response = await api.get<Envelope<AdminTutorialSetting>>('/admin/tutorials');
    return response.data.data;
  },

  async updateAdminSetting(payload: { enabled?: boolean; disabled_pages?: string[] }): Promise<AdminTutorialSetting> {
    const response = await api.put<Envelope<AdminTutorialSetting>>('/admin/tutorials', payload);
    return response.data.data;
  },

  /** pageKey 無指定なら全ページの既読を消す */
  async resetViews(pageKey?: string): Promise<AdminTutorialSetting> {
    const response = await api.delete<Envelope<AdminTutorialSetting>>('/admin/tutorials/views', {
      data: pageKey ? { page_key: pageKey } : {},
    });
    return response.data.data;
  },
};

export default tutorialService;
